// @ts-nocheck
export default {
  pt: {
    // Memberships section
    MEMBERSHIPS_SECTION_TITLE: 'Escolha sua assinatura preferida',
    MEMBERSHIPS_SECTION_TITLE_PROMO:
      'Escolha seus planos pelo preço de aniversário',
    MEMBERSHIPS_SECTION_NOTE: 'Nossas assinaturas são auto-renováveis',
    MEMBERSHIPS_SECTION_FEATURE_1: 'Acesso a todo o catálogo',
    MEMBERSHIPS_SECTION_FEATURE_2: 'Acesso a carreiras',
    MEMBERSHIPS_SECTION_FEATURE_3: 'Cursos Premium',
    MEMBERSHIPS_SECTION_FEATURE_4: 'Orientação personalizada',
    MEMBERSHIPS_SECTION_FEATURE_5: 'Carreiras com diplomas físicos',
    MEMBERSHIPS_SECTION_FEATURE_6: 'Acesso ao Skill IQ',
    MEMBERSHIPS_SECTION_FEATURE_7: 'Obtenha uma, presenteie outra',
    MEMBERSHIPS_SECTION_BUTTON_1: 'Iniciar meu plano',
    MEMBERSHIPS_SECTION_BUTTON_2: 'Agendar uma demonstração',
    MEMBERSHIPS_SECTION_BUTTON_3: 'Começar agora',
    MEMBERSHIPS_SECTION_ENTERPRISE_1:
      '¿Eres estudiante universitario o de instituto? Tenemos',
    MEMBERSHIPS_SECTION_ENTERPRISE_2: 'un plan especial para ti.',
    MEMBERSHIP_SECTION_YEARLY: 'Pagamento único anual de {{yearlyPrice}}',
    MEMBERSHIP_SECTION_MAX_MEMBERS:
      'Compartilhe com {{licences}} pessoa{{addedPlural}}',
    MEMBERSHIP_SECTION_MONTHLY: 'Cobrança mensal',

    RETRY: 'Tentar novamente',
    BECOME_PREMIUM: 'Aproveite agora',
    BECOME_PREMIUM_2: 'Aproveite agora',
    BECOME_PREMIUM_DESCRIPTION: 'Acesse tudo com descontos!',
    STICKY_FORM_CONTACT: 'Deixe seus dados e fale com um consultor',
    STICKY_FORM_CONTACT_BTN_LABEL: 'Contact me',
    PREMIUM_FOR_TWO: 'Premium agora é para dois!',
    GIFT_MEMBERSHIP_BANNER_MESSAGE:
      '#EuAprendoEmCasa: Premium agora é para dois!',
    GIFT_MEMBERSHIP_BANNER_SHORT_MESSAGE:
      '#EuAprendoEmCasa: Premium agora é para dois!',

    ENDS_IN: 'Termina em ',
    OFFER_ENDS_IN: 'Preço especial: termina em ',
    POPULAR: 'Mais comprados',
    INDIVIDUAL: 'Individual',
    DUO: 'Duo',
    FAMILY: 'Família',

    TOTAL_ACCOUNTS_FAMILY: 'Até 4 contas premium',
    TOTAL_ACCOUNTS_DUO: '2 Contas Premium',

    VIEW_DETAIL: 'Ver detalhes',
    SHOW_MORE: 'Mostre mais',
  },
};
